import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  baseStyle: {
    height: '450px',
    display: 'flex !important',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    border: `2px dashed #eeeeee`,
    borderRadius: 5,
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  },
  warning: {
    fontSize: 14,
    color: theme.palette.grey.A200
  }
}));
